import React from "react";

function PledgeMasterTable(props) {
  const gridData = props.gridData;

  return (
    <>
      <div className="table-responsive scroll-table report-table-wrapper">
        <table className="table last-column">
          <thead>
            <tr>
              <th scope="col">Report Date</th>
              <th scope="col" className="text-center">
                Client Name
              </th>
              <th scope="col" className="text-center">
                Client Code
              </th>
              <th scope="col" className="text-center">
                ISIN
              </th>
              <th scope="col" className="text-center">
                Pledge QTY.
              </th>
              <th scope="col" className="text-center">
                Pledgee
              </th>
              <th scope="col" className="text-center">
                Pledgor BO ID
              </th>
              <th scope="col" className="text-center">
                Pledgor
              </th>
            </tr>
          </thead>
          <tbody>
            {gridData &&
              gridData.map((item, key) => {
                return (
                  <tr key={key}>
                    <td>{item?.reportDate || "-"}</td>
                    <td>{item.clientName || "-"}</td>
                    <td>{item.clientCode || "-"}</td>
                    <td>{item.isIn || "-"}</td>
                    <td>{item.pledgQty || 0}</td>
                    <td>{item.pledg || 0}</td>
                    <td>{item.pledgOrBoId || 0}</td>
                    <td>{item.PledgOr || 0}</td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </>
  );
}
export default PledgeMasterTable;
